export const GuidelineTemplateKeys = {
  all: ['guidelineTemplates'] as const,
  lists: () => [...GuidelineTemplateKeys.all, 'list'] as const,
  list: (queryParams: string) => [...GuidelineTemplateKeys.lists(), { queryParams }] as const,
  fullList: () => [...GuidelineTemplateKeys.lists(), 'full'] as const,
  details: () => [...GuidelineTemplateKeys.all, 'detail'] as const,
  detail: (id: string) => [...GuidelineTemplateKeys.details(), id] as const,
};
